import React from 'react';
import IMsgExpandTextsDF from '../components/SimulatorsComponents/DefualtSimulators/IMsgExpandTextsDF';

//= ========================================================================

const Sim_T06_iMsgExpandTexts = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => (
  <IMsgExpandTextsDF
    globJSON={globJSON}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_T06_iMsgExpandTexts;
